import { filterCanceledRegulations } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/utils';
import {
  STATUS_PENDING,
  STATUS_REJECTED,
} from 'containers/LawyerFeeNote/constants';
import { ITEM_KEYS } from 'containers/RecapManagerPage/constants';
import { get, isEmpty, isNil, sumBy } from 'lodash';

export const sumAllRegulationsSagis = (
  contractorFees: any[],
  listings: any,
) => {
  const lawyers = !isEmpty(contractorFees)
    ? contractorFees.filter(el => el.contractorTypeCode === ITEM_KEYS.LAWYER)
    : [];

  const grouped = lawyers.reduce((acc, el) => {
    if (!acc[el.contractorCode]) {
      acc[el.contractorCode] = [];
    }
    acc[el.contractorCode].push(el);
    return acc;
  }, {} as Record<string, any[]>);

  const result = Object.entries(grouped).map(([contractorCode, items]: any) => {
    const allRegs = (items as any).flatMap((item: any) =>
      get(item, 'regulations', []),
    );
    const filtered = filterCanceledRegulations(
      get(listings, 'PaymentStatus', []),
      allRegs,
    );

    const sum = sumBy(filtered, o =>
      get(o, 'paidAmount', 0) === 0
        ? get(o, 'amount', 0)
        : get(o, 'paidAmount', 0),
    );

    return {
      codeIntervenant: contractorCode,
      sumSagisRegulations: sum,
    };
  });

  return result;
};

export const filterRejectedPendingFeeNotes = (feeNotes: any[] = []) => {
  return feeNotes.filter(
    feeNote => ![STATUS_PENDING, STATUS_REJECTED].includes(feeNote?.status),
  );
};

export const sumAllRegulationsCorpo = (feeNotes: any[]) => {
  const sum = sumBy(filterRejectedPendingFeeNotes(feeNotes), o =>
    isNil(get(o, 'costs')) ? get(o, 'amountTtc', 0) : get(o, 'costs', 0),
  );
  return [
    {
      codeIntervenant: get(feeNotes, '[0].codeIntervenant'),
      sumSagisRegulations: sum,
    },
  ];
};
